export const ACE_RULE_HASH_PREFIX = '#acerule=' as const
